import styled from "@emotion/styled";

export const MobileLogoImage = styled.img({
    /* size */
    height: 42,

    /* opacity */
    opacity: 0.75,
})